import React from 'react'
import { useRouter } from 'next/router'
import OverDueInvoicesBanner from 'src/components/billing/OverDueInvoicesBanner'
import ReactivationBanner from 'src/components/billing/ReactivationBanner'
import { TrialBanner } from 'src/components/common/TrialBanner'
import NavigationBar from 'src/components/navigation/PrimaryNavBarComponents/NavigationBar'
import useNavigation from 'src/lib/hooks/useNavigation'
import { classNames } from 'src/lib/utils/helpers'

interface MainLayoutProps {
  children: React.ReactNode
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const {
    getters: { sidebarOpen, isTablet }
  } = useNavigation()

  const sidebarWidthClass = classNames(
    isTablet ? 'w-auto' : '',
    !isTablet && !sidebarOpen ? 'w-[309px]' : '',
    !isTablet && sidebarOpen ? 'w-[282px]' : ''
  )

  const sidebarWidthPx = isTablet ? 64 : sidebarOpen ? 282 : 309

  return (
    <div
      className={classNames('flex flex-col h-screen w-full bg-zinc-50 overflow-hidden')}
      style={{ '--sidebar-width': `${sidebarWidthPx}px` } as React.CSSProperties}
    >
      <OverDueInvoicesBanner />
      <ReactivationBanner />
      <div className={classNames('flex flex-1 min-h-0')}>
        <div className={classNames(sidebarWidthClass, 'flex-shrink-0')}>
          <NavigationBar />
        </div>
        <MainContent>{children}</MainContent>
      </div>
    </div>
  )
}

const MainContent = ({ children }: { children: React.ReactNode }) => {
  const router = useRouter()
  const subscriptionsPath = router.asPath.split(/[?#]/)[0].replace(/\/+$/, '')
  const isFullHeightPage =
    router.pathname.startsWith('/pdp') ||
    router.pathname === '/home' ||
    router.pathname.startsWith('/segments') ||
    router.pathname.startsWith('/gift-cards') ||
    router.pathname === '/apps-integrations' ||
    router.pathname.startsWith('/apps-integrations/detail') ||
    router.pathname === '/quick-add-on' ||
    subscriptionsPath.startsWith('/subscriptions')

  return (
    <main
      id='main-content'
      className={classNames(
        'flex flex-1 min-w-0 flex-col',
        isFullHeightPage ? 'min-h-0 overflow-hidden' : 'overflow-y-auto'
      )}
      data-track-id='main-content'
    >
      <div className={classNames('flex min-w-0 flex-col', isFullHeightPage ? 'flex-1 min-h-0' : 'min-h-full flex-1')}>
        <TrialBanner />
        {children}
      </div>
    </main>
  )
}

export default MainLayout
